import type { DataGetter } from '@rea-argonaut/analytics';
import { trackEvent } from '@rea-argonaut/analytics';

export const trackSearchRefinementModalOpen = (): void => {
  const event: DataGetter = () => ({
    schema: 'iglu:au.com.property/pca_search_refinement_modal_open/jsonschema/1-0-1',
    data: {
      event_name: 'pca_search_refinement_modal_open',
      user_action: 'multiIntent',
    },
  });
  trackEvent(event);
};
